import React from 'react';
// @ts-ignore
import { useAppContext } from '../../Services/AppContext';
import Modal from '../Modal/Modal';
import WorkplaceCalendar from './WorkplaceCalendar';
import { IResponse } from '../../Services/ApiClient';

interface IWorkplaceCalendarModal {
	opened: boolean;
	onClose: any;
	patientId?: string;
	workplaceId?: string;
	caseId?: string;
	onEventIsCreated?: (response: IResponse) => void;
}

export default function WorkplaceCalendarModal(props: IWorkplaceCalendarModal) {
	const { opened, onClose, patientId, workplaceId, caseId, onEventIsCreated } =
		props;
	const { translation } = useAppContext();

	return (
		<div>
			<Modal opened={opened} onClose={onClose} fullScreen={true}>
				<Modal.Header
					title={translation['component.caseCreate.chooseADateAndTime']}
				/>
				<Modal.Content fullScreen={true}>
					<WorkplaceCalendar
						workplaceId={workplaceId}
						patientId={patientId}
						caseId={caseId}
						onEventIsCreated={onEventIsCreated}
					/>
				</Modal.Content>
			</Modal>
		</div>
	);
}
